const PREFIX = Object.freeze({
    OUTGOING: 'Mediasite',
    INCOMING: 'MediasitePlayer'
});

const DELIMITER = ':';

export function parseMessage(message) {
    // Expected message: 
    //     messagePrefix + messageDelimiter + JSON.stringify(object)

    var fullPrefix = `${PREFIX.INCOMING}${DELIMITER}`;

    if (message.indexOf(fullPrefix) !== 0) {
        throw new SyntaxError("Unable to parse message without prefix Mediasite.");
    }

    var jsonData = message.substring(fullPrefix.length);
    var data = JSON.parse(jsonData);

    return data;
}

export function buildMessage(event, data) {
    const messageData = { event, data };

    if (!Array.isArray(data)) {
        messageData.data = data ? [data] : [];
    }

    return `${PREFIX.OUTGOING}${DELIMITER}${JSON.stringify(messageData)}`;
}
